import Model from 'scomponent/src/data/model'
import fieldTranslation from '../../../.env.models.json'
import { ItemModel } from './ItemModel'

export class OrderDetailModel extends Model {
  private static instance: OrderDetailModel = new OrderDetailModel()
  id: number = 0
  orderId: number = 0
  amount: number = 0
  total: number = 0
  subtotal: number = 0
  productPrice: number = 0
  discount: number = 0
  product: ItemModel = new ItemModel()

  public static getInstance(): OrderDetailModel {
    this.instance.setTranslateField(fieldTranslation['PendingOrder']['details'])
    return OrderDetailModel.instance
  }
}
